import { ActionType } from '../../classes/calendar-actions';
import { IPromoCodeDetail } from '../../classes/promo-code';


export function requestPromoCodeApply() {
    return {
        type: ActionType.RequestPromoCodeApply
    }
}

export function requestPromoCodeRemove() {
    return {
        type: ActionType.RequestPromoCodeRemove
    }
}

export function updatePromoCodeString(promoCode: string) {
    return {
        type: ActionType.UpdatePromoCode,
        value: promoCode
    }
}

export function ShowPromoComponent(show: boolean) {
    return {
        type: ActionType.ShowPromo,
        value: show
    }
}

export function receivePromoCodeApplyResponse(promoCode: string, apiData: any) {
    return {
        type: ActionType.ReceivePromoCodeApply,
        value: {
            promoCode: promoCode,
            apiResponse: apiData
        }
    }
}

export function receivePromoCodeRemoveResponse(apiData: any) {
    return {
        type: ActionType.ReceivePromoCodeRemove,
        value: {            
            apiResponse: apiData
        }
    }
}

export function receivePromoCodeGetResponse(promoCodeDetail: IPromoCodeDetail) {
    return {
        type: ActionType.ReceivePromoCodeGet,
        value: {
            apiResponse: promoCodeDetail
        }
    }
}


export function errorPromoCodeApply(error: any) {
    return {
        type: ActionType.ErrorPromoCodeApply,
        value: {
            apiResponse: error
        }
    }
}

export function errorPromoCodeRemove(apiData: any) {
    return {
        type: ActionType.ErrorPromoCodeRemove,
        value: {
            apiResponse: apiData
        }
    }
}